module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAYAAAAi2ky3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpdLPTcMwFAbwz6ZBglMuSKWiKN2gI5AN6AYwAVxRVeFKVB2DMgEjhBHYIDk0KBKXXMGSH89VDQ6t3H/f6cV++sVOHnBAzp/m922VJ7YW2DOdSfkM0A0ThdHf6V7QH+IiihZ2SKzy+OQ4egXRVWPDmJetT2SR0yjKuOw3ERp/jLpqAXWm5SMvXButB5XqFbsithRLRC23ag2kn8OLd9fbnuaJNHydAGIjyfgfDXEEZGeTed9Dsk3I4kS2WXAz3zHx1msijIXAHZrrPC/mthxezvAvwr15DYbV5vXIL7QNFkIaUACrjaFBNeq+IRDpP1QPvYKkTrl0f61mNN2ErJzIJeG5+TpqKSnFrPRGIZQfps9/gwsmM6gAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/check-blue.png
// module id = oxtd
// module chunks = 46